/* 把自研 Go 后端的消息(WS 推送 / 历史接口) 适配成旧 chat store 认识的 msgBody 格式。
 * Go 字段: formUser/formUserId/toUser/toUserId/toGroup/content/customType/type/messageId/sessionId/createTime/revocationState/formNick/formAvatar
 * 旧 msgBody: chatType/type('txt'|'custom')/from/to/id/msg/time/ext/customEvent/customExts:{content}/isRecall
 */
export function goToMsgBody(p) {
    if (!p) return null
    const isGroup = !!p.toGroup
    const from = p.formUser || ''
    const to = isGroup ? p.toGroup : p.toUser || ''
    // 现网历史里文本消息常是 type='custom' + customType='text'，必须按 customType 判断纯文本
    const content = p.content || ''
    const ctype = inferCustomType(content, p.customType || '')
    const isText = !ctype || ctype === 'text'
    const t = isText ? 'txt' : 'custom'
    const timeMs = toMs(p.createTime)
    const body = {
        chatType: isGroup ? 'groupChat' : 'singleChat',
        type: t,
        from,
        to,
        id: p.messageId || String(p.id || ''),
        time: timeMs,
        ext: {},
        groupName: p.groupName || '',
        isRecall: p.revocationState === 2,
        // 透传，方便渲染/会话补充
        _dbId: p.id,
        _sessionId: p.sessionId,
        _formNick: p.formNick,
        _formAvatar: p.formAvatar
    }
    if (isText) {
        body.msg = content
    } else {
        body.customEvent = ctype || 'text'
        body.customExts = { content }
        body.msg = content
    }
    if (p.groupName) body.ext.groupName = p.groupName
    if (p.groupId) body.ext.groupId = p.groupId
    if (p.groupCreateTime) body.ext.groupCreateTime = p.groupCreateTime
    if (p.groupCategory !== undefined && p.groupCategory !== null) body.ext.groupCategory = p.groupCategory
    return body
}

// 批量（历史列表）转换，按 id 升序
export function goListToMsgBodies(list) {
    return (list || []).map(goToMsgBody).filter(Boolean)
}

function toMs(t) {
    if (!t) return Date.now()
    if (typeof t === 'number') return t
    // ISO8601 字符串
    const ms = Date.parse(t)
    return isNaN(ms) ? Date.now() : ms
}

function inferCustomType(content = '', customType = '') {
    if (customType && customType !== 'text') return customType
    if (typeof content !== 'string') return customType || ''
    const trimmed = content.trim()
    if (isLegacyGoodsCardContent(content)) {
        return 'goods'
    }
    if (content.includes('订单编号：') && content.includes('订单链接：')) {
        return 'PayType'
    }
    if (isLegacyOrderCardContent(content)) {
        return 'PayType'
    }
    if (extractDirectImageUrl(trimmed)) return 'image'
    if (extractDirectVideoUrl(trimmed)) return 'video'
    return customType || ''
}

export function isLegacyOrderCardContent(content = '') {
    if (typeof content !== 'string') return false
    return (
        content.includes('link@#$') &&
        content.includes('id@#$') &&
        /\/pages\/order\/orderDetail\?/i.test(content)
    )
}

export function isLegacyGoodsCardContent(content = '') {
    if (typeof content !== 'string') return false
    return content.includes('titleImg@#$') && content.includes('&&&link@#$')
}

export function isDirectImageUrl(value = '') {
    return !!extractDirectImageUrl(value)
}

export function isDirectVideoUrl(value = '') {
    return !!extractDirectVideoUrl(value)
}

export function extractDirectImageUrl(value = '') {
    return extractDirectMediaUrl(value, ['.png', '.jpg', '.jpeg', '.gif', '.webp', '.bmp', '.svg'], true)
}

export function extractDirectVideoUrl(value = '') {
    return extractDirectMediaUrl(value, ['.mp4', '.mov', '.m4v', '.webm', '.avi'], false)
}

function extractDirectMediaUrl(value = '', exts = [], allowImageHost = false) {
    const text = stringifyContent(value)
    if (!text) return ''
    const candidates = text.match(/https?:\/\/[^\s"'<>，。]+/gi) || []
    for (const raw of candidates) {
        const url = raw.replace(/[),\]}]+$/g, '')
        if (hasDirectMediaExt(url, exts, allowImageHost)) return url
    }
    return ''
}

function stringifyContent(value = '') {
    if (typeof value === 'string') {
        const trimmed = value.trim()
        if (!trimmed) return ''
        if ((trimmed.startsWith('{') && trimmed.endsWith('}')) || (trimmed.startsWith('[') && trimmed.endsWith(']'))) {
            try {
                return stringifyContent(JSON.parse(trimmed))
            } catch (e) {}
        }
        return trimmed
    }
    if (!value || typeof value !== 'object') return ''
    const keys = ['url', 'imgUrl', 'imageUrl', 'filePath', 'content', 'src', 'path']
    for (const key of keys) {
        if (typeof value[key] === 'string' && value[key]) return value[key]
    }
    try {
        return JSON.stringify(value)
    } catch (e) {
        return ''
    }
}

function hasDirectMediaExt(value = '', exts = [], allowImageHost = false) {
    if (typeof value !== 'string') return false
    const trimmed = value.trim()
    if (!/^https?:\/\/\S+$/i.test(trimmed)) return false
    try {
        const url = new URL(trimmed)
        const path = decodeURIComponent(url.pathname || '').toLowerCase()
        if (exts.some((ext) => path.endsWith(ext))) return true
        return allowImageHost && isKnownImageHost(url.hostname)
    } catch (e) {
        const clean = trimmed.split(/[?#]/)[0].toLowerCase()
        return exts.some((ext) => clean.endsWith(ext))
    }
}

function isKnownImageHost(hostname = '') {
    const host = hostname.toLowerCase()
    return host === 'img.zhwapp.com' || (host.endsWith('.pzds.com') && host.includes('oss'))
}
